/**
 * Constantes para el sistema de idle global
 */

// Prefijo para logs
export const LOG_PREFIX = '[IdleGlobal]';

// Tipos de mensajes
export const MESSAGE_TYPES = {
  ACTIVITY: 'activity' as const,
  LOGOUT: 'logout' as const,
} as const;

// Eventos de actividad humana que monitoreamos
export const ACTIVITY_EVENTS = {
  // Eventos inmediatos (sin throttle)
  IMMEDIATE: ['pointerdown', 'keydown', 'touchstart'] as const,
  
  // Eventos con throttle
  THROTTLED: ['pointermove', 'wheel'] as const,
} as const;

// Razones de logout
export const LOGOUT_REASONS = {
  IDLE_TIMEOUT: 'idle_timeout',
  MANUAL: 'manual',
  LEADER_COMMAND: 'leader_command',
} as const;

// Límites de rate limiting
export const RATE_LIMITS = {
  ACTIVITY_MESSAGES_PER_SECOND: 2,
  MIN_MESSAGE_INTERVAL_MS: 500,
} as const;

// Timeouts y delays
export const TIMEOUTS = {
  LEADER_ELECTION_DELAY_MS: 100,
  STORAGE_RETRY_DELAY_MS: 50,
  MAX_STORAGE_RETRIES: 3,
} as const;
